export default __webpack_public_path__ + "static/media/22-2_checkcircle.079a54bd.svg";